<template>
  <v-card class="container with-shadow rounded">
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="4" offset="1" class="icon-container">
          <v-icon :color="color">{{ this.icon }}</v-icon>
        </v-col>
        <v-col cols="7" class="info-container">
          <h2>{{ this.label }}</h2>
          <h1>{{ this.value }}</h1>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: String,
    label: String,
    value: Number,
    color: String
  }
}
</script>

<style></style>

<style lang="sass" scoped>
.container
  user-select: none
.icon-container
  text-align: left
  .v-icon
    font-size: 3rem
.info-container
  color: #666666
  h2
    font-weight: 500
  h1
    font-weight: 500
    margin-top: 10px
</style>
